import { State } from '../state/state';

export const getConnectionStatus = (state: State) => state.sockets.isConnected;

export const getSocketId = (state: State) => state.sockets.socketId;

export const getResourceType = (state: State) => state.sockets.resourceType;
